import {
  Button,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import colors from "../../Assest/Theme/Color";
import React, { useState } from "react";
import useTranslations from "../Translations/useTranslations";
import Routings from "../../Routings";
import { useNavigate } from "react-router-dom";

const Volunteersadd = () => {
    const { translations, languageSelect } = useTranslations();
    const navigate = useNavigate();
    const styles = {
        button: {
          backgroundColor: colors.lightButton,
          color: colors.black,
          fontSize: languageSelect === "Tamil" ? "14px" : "18px",
          fontWeight: "bold",
          textTransform: "none",
          padding: "8px 30px",
          borderRadius: "10px",
          "&:hover": {
            backgroundColor: colors.lightButton,
          },
        },
      };
  const [error, setError] = useState(null);
  const [, setProofDocumentFile] = useState(null);
  const [addVolunteers, setAddVolunteers] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    mobileNumber: "",
    emailId: "",
    gender: "Male",
    address: "",
    city: "",
    state: "",
    zip: "",
    previousSchool: "",
    areaOfInterest: "",
    resume: "",

    firstNameStatus: "unchecked",
    middleNameStatus: "unchecked",
    lastNameStatus: "unchecked",
    dobStatus: "unchecked",
    mobileNumberStatus: "unchecked",
    emailIdStatus: "unchecked",
    genderStatus: "unchecked",
    addressStatus: "unchecked",
    cityStatus: "unchecked",
    stateStatus: "unchecked",
    zipStatus: "unchecked",
    previousSchoolStatus: "unchecked",
    areaOfInterestStatus: "unchecked",
    resumeStatus: "unchecked",
  });

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log("SelectedFile:", file);
    // setIsUpdated(true);

    if (file) {
      if (file.type !== "application/pdf") {
        setError("Only PDF files are allowed.");
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        setError("File size must not exceed 2MB.");
        return;
      }

      setProofDocumentFile(file);
      setError("");
    }
  };
  const handleaddVolunteersChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...addVolunteers };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "firstName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "middleName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "lastName") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "mobileNumber") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "emailId") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "address") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "city") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "state") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "zip") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "previousSchool") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "areaOfInterest") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "firstName":
          {
            const alphaNLengthRegex = new RegExp("^([A-Za-z]{1,50})$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "middleName":
          {
            const alphaNLengthRegex = new RegExp("^([A-Za-z ]{1,50})$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastName":
          {
            const alphaNLengthRegex = new RegExp("^([A-Za-z]{1,50})$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "dob":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );

            if (dateLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mobileNumber":
          {
            const alphaNLengthRegex = new RegExp("^([0-9]{1,10})$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "emailId":
          {
            const emailRegex = new RegExp(
              "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
            );
            if (emailRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "address":
          {
            const alphaNLengthRegex = new RegExp("^[A-Za-z0-9.,()/@!#'\\-\\s]{1,150}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "city":
          {
            const alphaNLengthRegex = new RegExp("^([A-Za-z0-9 ]{1,50})$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "state":
          {
            const alphaNLengthRegex = new RegExp("^([A-Za-z0-9 ]{1,50})$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zip":
          {
            const alphaNLengthRegex = new RegExp("^([0-9 ]{1,6})$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "previousSchool":
          {
            const alphaNLengthRegex = new RegExp("^[A-Za-z0-9.,()/@!#'\\-\\s]{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "areaOfInterest":
          {
            const alphaNLengthRegex = new RegExp("^[A-Za-z0-9.,()/@!#'\\-\\s]{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setAddVolunteers(formState);
  };

  const handleGenderChange = (e) => {
    setAddVolunteers((prevReport) => ({
      ...prevReport,
      gender: e.target.value,
      genderStatus: "success",
    }));
  };
const handleFormClose =() => {
 window.scrollTo({ top: 0, behavior: "auto" });
 navigate(Routings.SUCCESS)
};
  const formClose = () => {
    navigate(Routings.HOME);
    window.scrollTo({ top: 0, behavior: "auto" });
  };
  return (
    <div style={{ paddingTop: "6rem", minHeight: "100vh", width: "90%", margin: "0 auto" }}>
      {/* <Card> */}
      <CardHeader
        title={
          <Stack direction="row" justifyContent="center" alignItems="center">
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ color: "#1eb9b3" }}
            >
              Add Volunteers
            </Typography>
          </Stack>
        }
      />
      <CardContent sx={{ minHeight: "80vh" }}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              First Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="firstName"
              placeholder="Enter First Name"
              value={addVolunteers.firstName}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.firstNameStatus === "error" ? true : false}
              success={
                addVolunteers.firstNameStatus === "success" ? true : false
              }
              fullWidth
            />
            {addVolunteers.firstNameStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                First Name must be between 1-50 alpha characters.
              </Typography>
            )}
          </Grid>

          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Middle Name
            </Typography>
            <TextField
              name="middleName"
              placeholder="Enter Middle Name"
              value={addVolunteers.middleName}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.middleNameStatus === "error" ? true : false}
              success={
                addVolunteers.middleNameStatus === "success" ? true : false
              }
              fullWidth
            />
            {addVolunteers.middleNameStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Middle Name must be between 1-50 alpha characters.
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Last Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="lastName"
              placeholder="Enter Last Name"
              value={addVolunteers.lastName}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.lastNameStatus === "error" ? true : false}
              success={
                addVolunteers.lastNameStatus === "success" ? true : false
              }
              fullWidth
            />
            {addVolunteers.lastNameStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Last Name must be between 1-50 alpha characters.
              </Typography>
            )}
          </Grid>

          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Date of birth
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="dob"
              type="date"
              value={addVolunteers.dob}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.dobStatus === "error" ? true : false}
              success={addVolunteers.dobStatus === "success" ? true : false}
              fullWidth
            />
            {addVolunteers.dobStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Date of birth is required.
              </Typography>
            )}
          </Grid>

          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Mobile Number
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="mobileNumber"
              placeholder="Enter Mobile Number"
              value={addVolunteers.mobileNumber}
              onChange={handleaddVolunteersChange}
              error={
                addVolunteers.mobileNumberStatus === "error" ? true : false
              }
              success={
                addVolunteers.mobileNumberStatus === "success" ? true : false
              }
              fullWidth
            />
            {addVolunteers.mobileNumberStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Phone number must be in 10 number.
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Email ID
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="emailId"
              placeholder="Enter Email ID"
              value={addVolunteers.emailId}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.emailIdStatus === "error" ? true : false}
              success={addVolunteers.emailIdStatus === "success" ? true : false}
              fullWidth
            />
            {addVolunteers.emailIdStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Enter Valid Email id
              </Typography>
            )}
          </Grid>

          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Address
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="address"
              placeholder="Enter Address"
              value={addVolunteers.address}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.addressStatus === "error" ? true : false}
              success={addVolunteers.addressStatus === "success" ? true : false}
              fullWidth
            />
            {addVolunteers.addressStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                addressStatus must be between 150 alpha characters.
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              City
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="city"
              placeholder="Enter city"
              value={addVolunteers.city}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.cityStatus === "error" ? true : false}
              success={addVolunteers.cityStatus === "success" ? true : false}
              fullWidth
            />
            {addVolunteers.cityStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                City must be between 1-50 alpha characters.
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              State
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="state"
              placeholder="Enter state"
              value={addVolunteers.state}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.stateStatus === "error" ? true : false}
              success={addVolunteers.stateStatus === "success" ? true : false}
              fullWidth
            />
            {addVolunteers.stateStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                State must be between 1-50 alpha characters.
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Previous School
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="previousSchool"
              placeholder="Enter Previous School"
              value={addVolunteers.previousSchool}
              onChange={handleaddVolunteersChange}
              error={
                addVolunteers.previousSchoolStatus === "error" ? true : false
              }
              success={
                addVolunteers.previousSchoolStatus === "success" ? true : false
              }
              fullWidth
            />
            {addVolunteers.previousSchoolStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Previous School must be between 1-50 alpha characters.
              </Typography>
            )}
          </Grid>

          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Zip Code
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="zip"
              placeholder="Enter Zip Code"
              value={addVolunteers.zip}
              onChange={handleaddVolunteersChange}
              error={addVolunteers.zipStatus === "error" ? true : false}
              success={addVolunteers.zipStatus === "success" ? true : false}
              fullWidth
            />
            {addVolunteers.zipStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Zip Code must be between 6 Number.
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Area Of Interest
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <TextField
              name="areaOfInterest"
              placeholder="Enter Area Of Interest"
              value={addVolunteers.areaOfInterest}
              onChange={handleaddVolunteersChange}
              error={
                addVolunteers.areaOfInterestStatus === "error" ? true : false
              }
              success={
                addVolunteers.areaOfInterestStatus === "success" ? true : false
              }
              fullWidth
            />
            {addVolunteers.areaOfInterestStatus === "error" && (
              <Typography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Area Of Interest must be between 1-50 alpha characters.
              </Typography>
            )}
          </Grid>

          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Proof Document
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>

            <TextField
              type="file"
              inputProps={{ accept: ".pdf" }}
              onChange={handleFileChange}
              fullWidth
              sx={{
                height: "50px",
                "& .MuiInputBase-root": { height: "50px", padding: "10px" },
              }}
            />

            {error && (
              <Grid item>
                <Typography variant="caption" color="error">
                  {error}
                </Typography>
              </Grid>
            )}
          </Grid>

          <Grid item xs={4}>
            <Typography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ textAlign: "left", display: "block" }}
            >
              Gender
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </Typography>
            <br />
            <FormControl sx={{ pl: 2, textAlign: "left", display: "block" }}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={addVolunteers.gender}
                onChange={handleGenderChange}
              >
                <FormControlLabel
                  value={"Male"}
                  control={<Radio size="small" />}
                  label="Male"
                />
                <FormControlLabel
                  value={"female"}
                  control={<Radio />}
                  label="Female"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </CardContent>
      <Grid
        item
        mt={1}
        xs={12}
        sx={{ display: "flex", justifyContent: "center", gap: 2 }}
      >
        <Button
          type="submit"
          variant="contained"
          sx={styles.button}
            onClick={handleFormClose}
          //   disabled={!isFormValid()}
        >
         {translations.submit_button}
        </Button>
        <Button
          type="cancel"
          variant="contained"
          sx={styles.button}
            onClick={formClose}
        >
          {translations.cancel_button}
        </Button>
      </Grid>

      {/* </Card> */}
    </div>
  );
};

export default Volunteersadd;
